// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2490":"1c3da0bb2d0c9458","4112":"a3ede44e6a0beb25","7843":"0e324a7932a453b4","8787":"a1e3a7d3afb0d21c"}[chunkId] + ".css";
};